class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        sliderInit();
var Ajaxinate = function (e) {
  const loadingIcon = `<div class="loading-overlay__spinner">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>`;
  var i = e || {},
    n = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: loadingIcon,
      callback: null,
    };
  (this.settings = Object.assign(n, i)),
  (this.addScrollListeners = this.addScrollListeners.bind(this)),
  (this.addClickListener = this.addClickListener.bind(this)),
  (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
  (this.stopMultipleClicks = this.stopMultipleClicks.bind(this)),
  (this.destroy = this.destroy.bind(this)),
  (this.containerElement = document.querySelector(this.settings.container)),
  (this.paginationElement = document.querySelector(this.settings.pagination)),
  this.initialize();
};

(Ajaxinate.prototype.initialize = function () {
  if (this.containerElement) {
    var e = { click: this.addClickListener, scroll: this.addScrollListeners };
    e[this.settings.method]();
  }
}),
(Ajaxinate.prototype.addScrollListeners = function () {
  this.paginationElement &&
  (document.addEventListener("scroll", this.checkIfPaginationInView),
  window.addEventListener("resize", this.checkIfPaginationInView),
  window.addEventListener("orientationchange",this.checkIfPaginationInView));
}),
(Ajaxinate.prototype.addClickListener = function () {
  this.paginationElement &&
    ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
    (this.clickActive = !0),
    this.nextPageLinkElement !== null &&
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks));
}),
(Ajaxinate.prototype.stopMultipleClicks = function (e) {
  e.preventDefault(),
    this.clickActive &&
      ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
      (this.nextPageUrl = this.nextPageLinkElement.href),
      (this.clickActive = !1),
      this.loadMore());
}),
(Ajaxinate.prototype.checkIfPaginationInView = function () {
  var e = this.paginationElement.getBoundingClientRect().top -  this.settings.offset,
      i = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
      e <= window.innerHeight &&  i >= 0 &&
        ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
        this.removeScrollListener(),
        this.nextPageLinkElement &&
        ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()));
}),
(Ajaxinate.prototype.loadMore = function () {
  (this.request = new XMLHttpRequest()),
  (this.request.onreadystatechange = function () {
    if (this.request.readyState === 4 && this.request.status === 200) {
console.log("filter working");
      var i = this.request.responseXML.querySelectorAll(this.settings.container)[0],
          n = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML("beforeend", i.innerHTML),
      (this.paginationElement.innerHTML = n.innerHTML),
      this.settings.callback &&
      typeof this.settings.callback == "function" &&
      this.settings.callback(this.request.responseXML),
      this.initialize();
      sliderInit();
      // atcProductCardBtn();
    }
  }.bind(this)),
  this.request.open("GET", this.nextPageUrl),
  (this.request.responseType = "document"),
  this.request.send();
}),
(Ajaxinate.prototype.removeClickListener = function () {
  this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
}),
(Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.checkIfPaginationInView),
    window.removeEventListener("resize", this.checkIfPaginationInView),
    window.removeEventListener("orientationchange", this.checkIfPaginationInView);
}),
(Ajaxinate.prototype.destroy = function () {
  var e = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  return e[this.settings.method](), this;
});
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '.AjaxinatePagination'
  });
      });


      
  // Start Add Product Card Slider
  function sliderInit() {
    document.querySelectorAll('.grid__item').forEach( productCard => {
      const sliderCard = productCard.querySelector('.product-card-slide-swiper');
  
      let px = new Swiper(sliderCard, {
        observer: true,
        observeParents: true,
        calculateHeight:true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
  
      if (productCard.querySelectorAll('.input-field-Color').length > 1) { 
        let selectedClrOpt = productCard.querySelectorAll('input:checked + .input-field-Color')[0];
  
         if (selectedClrOpt) {
          productCard.querySelectorAll(`.product_card_media_box`).forEach( mediaBox => {
            if (selectedClrOpt.dataset.variantValue === mediaBox.dataset.slideColor) {
              mediaBox.style.display = 'flex';
            } else {
              mediaBox.style.display = 'none';
            }
          });
          px.updateSize();
          px.updateSlides();
          px.updateProgress();
          px.updateSlidesClasses();
          px.slideTo(0);
        }
      }
   
      productCard.querySelectorAll('.input-field-Color').forEach( el => {
        el.addEventListener('click', (e) => {
          productCard.querySelectorAll('.product_card_media_box').forEach( mediaBox => {
            let Img = mediaBox.querySelector('img');
            if (Img.getAttribute('alt') === e.target.dataset.variantValue) {
              productCard.querySelectorAll(`.product_card_media_box`).forEach( mediaBox => { 
                if (e.target.dataset.variantValue === mediaBox.dataset.slideColor) {
                  mediaBox.style.display = 'flex';
                } else {
                  mediaBox.style.display = 'none';
                }
              });
              px.updateSize();
              px.updateSlides();
              px.updateProgress();
              px.updateSlidesClasses();
              px.slideTo(0);
            }
          });
        });
      });
    });
  }
    
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Re-initialize infinite scroll after the product grid is replaced
    if (typeof window.setupCollectionAjaxinate === 'function') {
      window.setupCollectionAjaxinate();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
